<section class="empty_list empty">
  <div class="container empty__content">
    <h3 class="title empty__title">{{ 'empty_page.title' | translate }}</h3>
    <img src="/assets/image/empty/empty_box.png" srcset="
        /assets/image/empty/empty_box.png    1x,
        /assets/image/empty/empty_box_2x.png 2x,
        /assets/image/empty/empty_box_3x.png 3x
      " class="empty__image" />
    <p class="empty__description">
      {{ 'empty_page.description' | translate }}
    </p>
    <a class="empty__link" [routerLink]="['/', lang, 'marketplace']" routerLinkActive="active">
      <button class="button-big empty__link">
        {{ 'empty_page.button' | translate }}
      </button>
    </a>
  </div>
</section>